import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';
import block from 'propmods';

import { CheckIcon } from '../../icons/check';
import { CrossIcon } from '../../icons/cross';
import { completedModerationStateTexts, draftStatusLabels } from '../../locale/ru/draftStatus';
import { DraftStatus } from '../../model/draft';
import { Channel } from '../../model/skill';

import './ModerationPipelineItem.scss';

const b = block('ModerationPipelineItem');
const t = i18n(keyset);

export type ModerationPipelineItemState = 'completed' | 'current' | 'not-started' | 'rejected';

interface Props {
    channel: Channel;
    draftStatus: DraftStatus;
    state: ModerationPipelineItemState;
    position: number;
    slaTimingsText?: string;
    showSuccessText?: boolean;
}

interface IconProps {
    position: number;
    state: ModerationPipelineItemState;
}

const ModerationPipelineItemIcon: React.FC<IconProps> = ({ state, position }) => {
    switch (state) {
        case 'completed':
            return <CheckIcon size="m" color="#fff" type="stroke" />;
        case 'current':
            return <div {...b('number')}>{position}</div>;
        case 'not-started':
            return <div {...b('number')}>{position}</div>;
        case 'rejected':
            return <CrossIcon size="xs" color="#fff" />;
    }
};

export const ModerationPipelineItem: React.FC<Props> = ({
    channel,
    draftStatus,
    state,
    position,
    children,
    slaTimingsText,
    showSuccessText = true,
}) => {
    return (
        <div {...b({ state })}>
            <div {...b('icon')}>
                <ModerationPipelineItemIcon state={state} position={position} />
            </div>
            <div {...b('body')}>
                <div {...b('label')}>
                    {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (draftStatusLabels as any)[channel][draftStatus]
                    }
                </div>
                {showSuccessText && state === 'completed' && (
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    <div {...b('status')}>{(completedModerationStateTexts as any)[channel][draftStatus]}</div>
                )}
                {state === 'rejected' && <div {...b('status')}>{t('skill-rejected')}</div>}
                {children}
                {slaTimingsText && <div {...b('timings')}>{slaTimingsText}</div>}
            </div>
        </div>
    );
};
